import MoovAccountsList from '@/views/Organizations/Moov/MoovAccountsList';

const MoovTab = ({ organizationId }) => {
  return <MoovAccountsList organizationId={organizationId} />;
};

export default MoovTab;
